import { render } from "./StopwatchIcon.vue?vue&type=template&id=f40e85de"
import script from "./StopwatchIcon.vue?vue&type=script&lang=js"
export * from "./StopwatchIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__